import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Optional } from '@angular/core';
import { IProductConfigurableSelection, IProductData, IProductDataV3 } from '@df/catalog/product/product';
import { OptionColorPipe } from '@df/ui/common/option-color.pipe';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ReviewsIORatingComponent } from 'projects/app-default/src/app/module/reviews-io/components/reviews-io-rating.component';
import { ModalLayoutRightComponent, NModalLayoutRight } from 'projects/app-default/src/app/ui/modal/modal-layout-right.component';
import { NProductViewLayout, Product } from '../../../product.decorator';
import { ProductViewConfigurableOptionsComponent } from '../../../view-configurable-options/product-view-configurable-options.component';
import { ProductViewCrosssellProductsColorComponent } from '../../../view-crosssell-products/color/product-view-crosssell-products-color.component';
import { ProductViewDimensionsAndDetailsComponent } from '../../../view-dimensions-and-details/product-view-dimensions-and-details.component';
import { ProductViewMediaComponent } from '../../../view-media/product-view-media.component';
import { ProductViewPriceComponent } from '../../../view-price/product-view-price.component';
import { ProductViewSamplesComponent } from '../../../view-samples/product-view-samples.component';
export const PRODUCT_VIEW_UPSELL_PRODUCT_MODAL__ID = 'productViewUpsellProduct';
export interface IProductViewUpsellProductModalContent {
    content: NProductViewLayout.IBlockDataContent;
    product: Product<IProductDataV3>;
    onConfirm: (product: Product<IProductDataV3>) => void;
}
@DfModal({
    id: PRODUCT_VIEW_UPSELL_PRODUCT_MODAL__ID,
    position: 'right',
    config: sizeName => ({
        ...NModalLayoutRight.ModalConfig,
        width: NModalLayoutRight.getWidth(sizeName)
    }),
    reopenPolicy: NDfModal.ReopenPolicy.first,
    sizeRestriction: ['S', 'M', 'L', 'X']
})
@Component({
    selector: 'product-view-upsell-product-modal',
    templateUrl: './product-view-upsell-product-modal.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        TranslationModule,
        ProductViewDimensionsAndDetailsComponent,
        ProductViewSamplesComponent,
        ProductViewPriceComponent,
        ProductViewMediaComponent,
        ModalLayoutRightComponent,
        ProductViewCrosssellProductsColorComponent,
        ProductViewConfigurableOptionsComponent,
        ReviewsIORatingComponent,
        OptionLabelPipe,
        OptionColorPipe
    ]
})
export class ProductViewUpsellProductModalComponent {
    hasVisibleOptions = false;
    constructor(
        @Optional()
        private modalRef: ModalRef<ProductViewUpsellProductModalComponent>,
        protected ref: ChangeDetectorRef,
        @Optional()
        @Inject(MODAL_DATA)
        public content: IProductViewUpsellProductModalContent
    ) {}
    /**
     * Close notification
     */
    close(): void {
        this.modalRef.close();
    }
    /**
     * Handles configurable change
     */
    onSelectionChange(filterModel: IProductConfigurableSelection): void {
        const newProduct = this.parentProduct.matchChild(filterModel) as Product<IProductDataV3>;
        if (newProduct) {
            this.content.product = newProduct;
            this.detectChanges();
        }
    }

    onProductConfigurablesInit($event) {
        const vm = $event.vm as ProductViewConfigurableOptionsComponent;
        this.hasVisibleOptions = !!vm.visibleAttributes?.length;
        this.detectChanges();
    }

    confirm(): void {
        this.content.onConfirm(this.content.product);
        this.close();
    }

    get parentProduct(): Product<IProductDataV3> {
        return this.content.product.parent as Product<IProductDataV3>;
    }

    get displayColorCrossSells(): boolean {
        if (this.content.product.hasColorCrosssells) {
            if (this.content.product?.parent?.isConfigurable) {
                return !this.hasVisibleOptions;
            }
            return true;
        }
        return false;
    }
    detectChanges(): void {
        this.ref.detectChanges();
    }

    onCrossellProductClick(product: Product<IProductData>): void {
        this.content.product = product as Product<IProductDataV3>;
        this.detectChanges();
    }
    asString(value: string | number): string {
        return value as string
    }
}
